export const character = [
    {
        id: 1,
        name: '<ruby>侑子<rt>ゆうこ</rt></ruby>',
        fullImage: 'assets/characters/yuko-open-mouth.png',
        normalImage:'assets/characters/yuko-normal.png',
        openMouth: 'assets/characters/yuko-open-mouth.png',
        headImage: 'assets/characters/chizuru6.png',
        goodAnswerImg: 'assets/characters/yuko-happy.png',
        badAnswerImg: 'assets/characters/yuko-sad.png',
        loadingImg:'assets/characters/yuko-loading.png',
        description: "<ruby>少<rt>すこ</rt></ruby>し" +
            "<ruby>恥<rt>は</rt></ruby>ずかしがり<ruby>屋<rt>や</rt></ruby>の<ruby>女<rt>おんな</rt></ruby>" +
            "の<ruby>子<rt>こ</rt></ruby> " +
            "<ruby>好<rt>す</rt></ruby>きなことは<ruby>買い物<rt>かいもの</rt></ruby>、カフェ<ruby>巡<rt>めぐ</rt></ruby>り",
        introText: '<p>このゲームは表示されたテキストを読む練習モードとフリートークの実践モードがあります。\n' +
            'どちらをやりますか？</p>',
        characterDescription: "<p>こんにちは。<ruby>侑子<rt>ゆうこ</rt></ruby>です。</p><p><ruby>好 <rt>す</rt></ruby>きなことは" +
            " <ruby>買<rt>か</rt></ruby>い<ruby>物<rt>もの</rt></ruby>とカフェ<ruby>巡<rt>めぐ</rt></ruby>りです。よろしくおねがいします。</p>"

    }
]
